<template>
  <div id="features" class="cd-section">
    <!--     *********     FEATURES      *********      -->
    <div class="features-1">
      <div class="container">
        <div class="row">
          <div class="col-md-8 mr-auto ml-auto">
            <h2 class="title">
              Was kann ich damit anfangen?
            </h2>
            <h4 class="description">
              123db ist eine Anwendung, um Ihre Daten zu verwalten, und sich im Arbeitsalltag unterstützen zu lassen.
              Welche Funktionen Sie nutzen, hängt allein von Ihren Bedürfnissen ab.
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="info info-hover">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons users_single-02" />
              </div>
              <h4 class="info-title">
                Stammdaten (CRM)
              </h4>
              <p class="description">
                Behalten Sie Ihre Kundendaten im Griff. Oder die Arbeitszeiten Ihrer Mitarbeiter. Oder die Anschriften
                Ihrer Lieferanten.
                123db ist ein vollwertiges CRM-System, das Sie auch in Ihrer Hosentasche immer mit sich führen können.
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="info info-hover">
              <div class="icon icon-danger icon-circle">
                <i class="now-ui-icons business_chart-bar-32" />
              </div>
              <h4 class="info-title">
                Sales
              </h4>
              <p class="description">
                Behalten Sie Ihre Einkaufs- und Verkaufsprozesse im Blick. Vom Angebot, über die Bestellung beim
                Lieferanten bis zur Auslieferung
                an den Endkunden und Rechnungslegung. Natürlich auch von unterwegs!
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="info info-hover">
              <div class="icon icon-warning icon-circle">
                <i class="now-ui-icons business_bulb-63" />
              </div>
              <h4 class="info-title">
                (KI-)Automatisierung
              </h4>
              <p class="description">
                Laden Sie den Scan Ihrer Eingangsrechnung hoch, und überlassen die Zuordnung zum richtigen Datensatz
                der KI*.<br />
                Sie hatten einen langen Freitag, und Ihre Projektzeitzuordnung ist unvollständig geblieben? 123db
                erinnert Sie am kommenden Montag,
                welche Einträge noch offen sind.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--     *********    END FEATURES      *********      -->
    <!--     *********     FEATURES PASST DAS      *********      -->
    <div class="features-3">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <h2 class="title">
              Passt das überhaupt in mein Unternehmen, und zu meinen aktuellen Anwendungen?
            </h2>
            <h4 class="description">
              123db hat schon in verschiedensten Umgebungen einen Platz gefunden.
              Ob als Ablöse für ein Primärsystem, oder als spezialisiertes Zusatzsystem, das Ihr
              Primärsystem mit den aggregierten Daten füttert - alles ist möglich und wird auf Ihren
              Bedarf maßgeschneidert.
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="info info-hover">
              <div class="icon icon-success icon-circle">
                <i class="now-ui-icons objects_globe" />
              </div>
              <h4 class="info-title">
                Webanwendung
              </h4>
              <p class="description">
                123db ist eine Webanwendung und braucht nur einen Webserver um einsatzbereit zu sein.
                Keine Installationen auf den Geräten Ihrer Mitarbeiter und eine zentrale Administration für Sie.
                Nutzen Sie es auf Windows, Mac, Linux, Android und/oder Ihrem iPhone - alle Funktionen sind
                auf Ihrer bestehenden Hardware nutzbar.
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="info info-hover">
              <div class="icon icon-info icon-circle">
                <i class="now-ui-icons education_atom" />
              </div>
              <h4 class="info-title">
                Atomar - oder voll integriert
              </h4>
              <p class="description">
                123db kann Ihren bestehenden Systemen Daten liefern, oder selbst entgegennehmen und weiterverarbeiten.
                Ob Sie 123db als zentrales System einsetzen, oder nur Ihre Kundendaten ohne viel "Drumherum" in einem
                eigenen System abspeichern wollen,
                das liegt bei Ihnen. Den größten Vorteil haben Sie natürlich, wenn all Ihre Geschäftsdaten in einem
                System gebündelt werden. Wie das gehen soll? Finden wir es in einem
                <a href="https://calendly.com/boigner-digital-gmbh/30min" target="_blank">gemeinsamen Termin</a>
                heraus!
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="info info-hover">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons tech_watch-time" />
              </div>
              <h4 class="info-title">
                Schnell mal anschauen?
              </h4>
              <p class="description">
                Kein Werbetext beantwortet die Frage, ob etwas passt, wirklich hilfreich. Aber es gibt ein
                Präsentationssystem, das wir für eine Demonstration
                <a href="https://calendly.com/boigner-digital-gmbh/30min" target="_blank">nach einem Ersttermin</a>
                für Sie und Ihr Unternehmen so anpassen, dass Sie sich etwas darunter vorstellen können.
                <br />
                Wenn Sie es sich schon vorher alleine ansehen wollen, verstehen wir das natürlich!
                <a href="https://test.123db.at/presentation" target="_blank" @click.prevent="redirect('123DBpresentation')">
                  Hier kommen Sie zum Präsentationssystem.</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--     *********    END FEATURES      *********      -->
    <!--     *********     FEATURES HOSTING      *********      -->
    <div class="features-3">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <h2 class="title">
              Einrichtung und Hosting.
            </h2>
            <h4 class="description">
              Wir richten 123db für Sie ein. In weiterer Folge entscheiden Sie, ob Sie die infrasturkturseitige
              Administration
              selbst übernehmen möchten, oder ob wir uns um Updates und Backups kümmern sollen.
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="info info-hover">
              <div class="icon icon-success icon-circle">
                <i class="now-ui-icons location_world" />
              </div>
              <h4 class="info-title">
                Cloud
              </h4>
              <p class="description">
                Von überall aus erreichbar, und Sie brauchen keinen Server am Betriebsgeländer aufzubauen.
              </p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="info info-hover">
              <div class="icon icon-info icon-circle">
                <i class="now-ui-icons location_pin" />
              </div>
              <h4 class="info-title">
                On-Premises
              </h4>
              <p class="description">
                Sie besitzen bereits einen Webserver vor Ort, oder wollen Ihre Daten lieber im Haus behalten?
                Kein Problem.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--     *********    END FEATURES HOSTING      *********      -->
    <!--     *********     FEATURES 2      *********      -->
    <div class="features-5">
      <div class="container">
        <div class="row">
          <div class="col-md-8 mx-auto">
            <h2 class="title">
              Zusätzliche Argumente für 123db?
            </h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons objects_planet" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Open Source
                </h4>
                <p>
                  Keine Bindung an einen Großkonzern, und in jedem Aspekt erweiterbar.
                </p>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons tech_mobile" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Responsive
                </h4>
                <p>
                  Die Anschrift Ihres Kunden immer greifbar, auch auf Mobilgeräten.
                </p>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons ui-2_settings-90" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Flexibel erweiterbar
                </h4>
                <p>
                  Oft ergeben sich Anforderung an die eigenen Anwendungen erst im Betrieb.
                  123db ist modular aufgebaut und jederzeit erweiterbar.
                </p>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons business_bank" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Datensouveränität
                </h4>
                <p>
                  Sperriges Wort, aber in der heutigen Zeit wichtiger denn je. Wenn Sie nicht
                  durch/bei einem großen amerikanischen Provider eingesperrt werden wollen,
                  dann ist 123db das Richtige für Sie. Ihre Daten bleiben bei Ihnen im Haus,
                  oder in dem von Ihnen gewählten Rechenzentrum. Wenn Sie diese Infrastruktur-Themen lieber
                  abgeben wollen, übernehmen wir das gerne für Sie. Wir setzen
                  auf ein ISO-zertifiziertes Rechenzentrum in Deutschland, um stets DSGVO-konform
                  zu sein.
                </p>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons business_bank" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Bankdatenimport
                </h4>
                <p>
                  Sehen Sie Eingänge auf Ihr Konto direkt in Ihrem zentralen System und verknüpfen diesen direkt mit der
                  ausgestellten Rechnung.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons design_vector" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Schnittstellen und Anbindungen an Fremdsysteme
                </h4>
                <p>
                  Integrationen mit bestehenden internen oder externen Systemen sind über die bereits vorhandene API
                  (Application Programming Interface - (Programmier-)Schnittstelle),
                  oder durch von uns individuell erstellte Schnittstellen möglich.
                </p>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons business_bulb-63" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Ready for KI - wenn Sie es sind
                </h4>
                <p>
                  Auch alle KI-Funktionalitäten benutzen die standardmäßige API, wobei Sie steuern können,
                  welche Daten Sie mit der KI teilen und welche Ihr verborgen bleiben sollen.
                  Weiters richten wir Ihr System so für Sie ein, dass die KI nur das darf,
                  was Sie auch wollen. Es soll für Sie Kunden anlegen und bspw. ein Angebot vorbereiten? Kein Problem.
                  Aber einen Kunden nachbearbeiten bzw. ein bestehendes Angebot löschen? Keinesfalls! Oder falls doch
                  vielleicht nur jene, die die KI selbst angelegt hat? Sie entscheiden.
                </p>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons emoticons_satisfied" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Aufs Wesentliche reduziert
                </h4>
                <p>
                  Nicht jeder braucht ein ausgewachsenes Inventarsystem, oder mehrere Adressfelder pro Kundenkartei.
                  Was nicht gebraucht wird kann entfernt oder ausgeblendet werden, was fehlt wird ergänzt.
                  Von der Navigation bis zum Detailformular.
                </p>
              </div>
            </div>
            <div class="info info-horizontal">
              <div class="icon icon-primary icon-circle">
                <i class="now-ui-icons ui-1_email-85" />
              </div>
              <div class="description">
                <h4 class="info-title">
                  Mails und Reporting
                </h4>
                <p>
                  Erstellen Sie an für Ihr Unternehmen angepasste Reports basierend auf den Daten in 123db.
                  Versenden Sie Mails direkt aus 123db, oder lassen Sie sich den aktuellsten Report zu Ihren offenen
                  Punkten automatisch zusenden.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--     *********    END FEATURES 2      *********      -->
    <div class="container description">
      * KI-Funktionen sind aktuell in Entwicklung - wir setzen hier auf das Prinzip "Human in the loop", damit Sie
      die volle Kontrolle behalten.
      <br />
      &nbsp;
    </div>
  </div>
</template>
<script>
import { Card } from '@/components';
export default {
  components: {
    Card
  },
  data() {
    return {
      redirecting: false
    }
  },
  methods: {
    async redirect(urlId) {
      const espoClient = this.useEspoClient();

      try {
        this.redirecting = true;
        const response = await espoClient.get(`redirect/${urlId}`);
        this.redirecting = false;
        
        if (response?.url) {
          window.open(response.url, '_blank');
        }
      } 
      catch {
        // Fail silently.
      }
      finally {
        this.redirecting = false;
      }
    }
  }
}
</script>
<style></style>
